export default {
    domains: state => state.domains
}